<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modalNew" hide-footer title="Tax table - new">
        <div class="d-block">
            <form v-on:submit.prevent="createNew">
                <div class="form-group">
                    <label for="lowerValue">Lower value</label>
                    <input type="number" 
                    step="any"
                    class="form-control" 
                    id="first" 
                    placeholder="Lower value"
                    v-model="lowerValue">
                    <div class="invalid-feedback" v-if="errors.lowerValue">{{ errors.lowerValue[0] }}</div>
                </div>
                <div class="form-group">
                    <label for="upperValue">Upper value</label>
                    <input type="number" 
                    step="any"
                    class="form-control" 
                    id="upperValue" 
                    placeholder="Upper value"
                    v-model="upperValue">
                    <div class="invalid-feedback" v-if="errors.upperValue">{{ errors.upperValue[0] }}</div>
                </div>
                <div class="form-group">
                    <label for="taxRate">Tax rate</label>
                    <input type="number" 
                    step="any"
                    class="form-control" 
                    id="taxRate" 
                    placeholder="Tax rate"
                    v-model="TaxRate">
                    <div class="invalid-feedback" v-if="errors.TaxRate">{{ errors.TaxRate[0] }}</div>
                </div>
                <hr>
                <div class="text-right">
                    <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
                    <button type="submit" class="btn btn-primary btn-sm">Save</button>
                </div>
            </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as taxTableService from '../../services/taxTable.service';
    export default {
        name:"ModelTaxTableNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                lowerValue:'',
                upperValue:'',
                TaxRate:'',
            }
        },
        methods:{
            ...mapActions([
                'fetchTaxTableAll'
            ]),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modalNew.hide();
            },
            showModal(){
                this.$refs.modalNew.show();
            },

            createNew:async function(){
                const formData = new FormData();
                formData.append('lowerValue',this.lowerValue);
                formData.append('upperValue',this.upperValue);
                formData.append('TaxRate',this.TaxRate);
            try{
                await taxTableService.add(formData);
                this.hideModal();

                this.fetchTaxTableAll();

                messageService.fnSweetAlertSuccessToast('Tax table - new', 'Added successfully');

                this.lowerValue = '';
                this.upperValue = '';
                this.TaxRate = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Tax table - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Tax table - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>